import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axiosInstance from "../../Component/axiosInstance";
import axiosInstance from "../../../Component/axiosInstance";
import Cookies from 'js-cookie';

// Async thunk for adding a company
const addTransportDetail = createAsyncThunk('transportDetail', async ({transport_detail , projectid}, { rejectWithValue }) => {
    try {
        // console.log("yo hai transhport detail ",transport_detail , projectid);
        const response = await axiosInstance.post(`/project/addTraskportProjection`, transport_detail, {
            headers: {
                'x-auth-token': localStorage.getItem('token'),
                'x-project-id':projectid
            }
        });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "An unexpected error occurred");
    }
});

// Slice for managing add company state
const addTransportDetailSlice = createSlice({
    name: 'AddtransportDetail',
    initialState: {
        loading: false,
        error: null,
        data: null,
        isSuccess: false,
        isError: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addTransportDetail.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.data = null;
                state.isSuccess = false;
                state.isError = false;
            })
            .addCase(addTransportDetail.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.isSuccess = true;
                state.isError = false;
            })
            .addCase(addTransportDetail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.data = null;
                state.isError = true;
                state.isSuccess = false;
            });
    }
});

export { addTransportDetail };
export default addTransportDetailSlice.reducer;